import { TrashPage } from "@/features/mentions/TrashPage";
import { useAppShell } from "@/shell/app-shell-context";
import { ApiState } from "@/shared/components/ApiState";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
import { hasRoleAtLeast } from "@/shared/utils/roles";

/** A lixeira de menções da empresa (2026-10-18). */
export function TrashRoute() {
  const { token, profile, openMention, mentionChange } = useAppShell();
  const company = useRequireCompany();

  if (!company) return null;
  // Mesmo papel que a API exige pra restaurar e descartar (2026-10-24).
  if (!hasRoleAtLeast(profile, "technician")) {
    return <ApiState kind="error">A Lixeira é de Técnico ou acima.</ApiState>;
  }

  return (
    <TrashPage
      token={token}
      companyId={company.id}
      openMention={openMention}
      mentionChange={mentionChange}
    />
  );
}
